import $ from 'jquery'
import LazyLoad from "vanilla-lazyload"
import { gsap, Power1 } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import 'jquery-modal'


gsap.registerPlugin(ScrollTrigger)

/* SETUP SLICK
  ----------------------------- */
export const setupSlideshow = (el, type = 'basic', slidesNumber = 1) => {
  const $el = $(el);
  const opts = {
    basic: {
      autoplay: false,
      dots: false,
      arrows: true,
      infinite: false,
      fade: false,
      slidesToShow: 3,
      responsive: [{
        breakpoint: 780,
        settings: {
          slidesToShow: 1,
        }
      }]
    }
  }

  $el.slick(opts[type])
}

/* LAZY LOAD
  ----------------------------- */
export const lazyLoad = () => {
  const lazyLoadInstance = new LazyLoad({
    elements_selector: ".lazy",
    data_src: "src",
  })
}

/* HEADER ANIMATION
  ----------------------------- */
export const menuResponsive = () => {
  $('.title-menu-mobile').on('click', function () {
    console.log("click");
    $('#block-pizzighettone-main-menu .block-content').toggleClass('mobile-hide');
  })
}


// WEBPACK FOOTER //
// ./src/js/functions.js